module.exports = __webpack_public_path__ + "img/case_3.3c99cf03.svg";